module.exports = __webpack_public_path__ + "img/testimonial2.6.18d6d255.jpeg";